export const NOTIFICATION_COUNTS_UPDATED = 'notification-counts-updated';

export type NotificationCountsDetail = {
  unreadCount: number;
};

export function notifyNotificationCountsUpdated(detail?: NotificationCountsDetail): void {
  window.dispatchEvent(new CustomEvent(NOTIFICATION_COUNTS_UPDATED, { detail }));
}
